import React from 'react'
import { Breadcrumb } from 'semantic-ui-react';
import EllipsisTooltip from '../../../../common/EllipsisTooltip';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
class BreadCrumbsPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            nodeMap: new Map()
        }
    }
    navigateTo(path) {
        const history = this.props.history;
        history.push({
            pathname: `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_cm${path}`
        });
    }
    createParentsArray = (nodes = []) => {
        nodes && nodes.length !== 0 && nodes.forEach(node => {
            this.state.nodeMap.set(node._id, node);
            node.breadcrumbs = [];
            if (node.parentOrganizationId && this.props.selectedOrganisation && node.parentOrganizationId !== this.props.selectedOrganisation.id) {
                let parentObject = this.state.nodeMap.get(node.parentOrganizationId);
                if (parentObject) {
                    node.breadcrumbs = [...parentObject.breadcrumbs]
                }

            }
            node.breadcrumbs.push({
                label: node.label,
                id: node._id,
                parentId: node.parentOrganizationId
            });
            if (node.nodes) {
                this.createParentsArray(node.nodes);
            }
        })
    }
    componentWillReceiveProps(nextProps) {

        if (this.props.nodes) {

            this.createParentsArray(nextProps.nodes);
        }

    }


    render() {
        let orgTree = this.props.selectedSubOrg && this.props.selectedSubOrg._id !== this.props.selectedOrganisation.id ?
            this.state.nodeMap.get(this.props.selectedSubOrg._id) && this.state.nodeMap.get(this.props.selectedSubOrg._id).breadcrumbs.map((parent, i) => {
                return (<React.Fragment key={i}>
                    <Breadcrumb.Divider icon='right angle' />
                    <Breadcrumb.Section onClick={()=>this.navigateTo(`/team/${parent.id}`)}>
                        <EllipsisTooltip
                            position="bottom left"
                            name={parent.label}
                            style={{ lineHeight: "17px" }}
                        />
                    </Breadcrumb.Section>
                </React.Fragment>)
            }) : null
        let users = this.props.mainAreaContext === "USERS" ?
            <React.Fragment >
                <Breadcrumb.Divider icon='right angle' />
                <Breadcrumb.Section >
                    {this.props.userRole === "users" ? "Users & Roles" :
                        this.props.userRole === "workspaceOwner" ? "Workspace Owner" :
                            this.props.userRole === "Manager" ? "Managers" :
                                this.props.userRole === "Member" ? "Members" :
                                    this.props.userRole}
                </Breadcrumb.Section>
            </React.Fragment> : null

        let addTeam = this.props.match.params.addTeamPageId ?
            <React.Fragment >
                <Breadcrumb.Divider icon='right angle' />
                <Breadcrumb.Section >Add Team</Breadcrumb.Section>
            </React.Fragment> : null

        let addUser = this.props.match.params.addUserPageId ?
            <React.Fragment >
                <Breadcrumb.Divider icon='right angle' />
                <Breadcrumb.Section >Add / Invite User</Breadcrumb.Section>
            </React.Fragment> : null

        // this.props.mainAreaContext === "Permissions" ? 
        //         <Breadcrumb className="breadCrumbs" size='small'>
        //             <Breadcrumb.Section  >{this.props.selectedOrganisation.name}</Breadcrumb.Section>
        //             <Breadcrumb.Divider icon='right angle' />
        //             <Breadcrumb.Section >Permissions</Breadcrumb.Section>
        //         </Breadcrumb> :

        let breadCrumb = <Breadcrumb className="breadCrumbs" >
            <Breadcrumb.Section  onClick={()=>this.navigateTo("")}>Teams</Breadcrumb.Section>
            <React.Fragment >
                <Breadcrumb.Divider icon='right angle' />
                <Breadcrumb.Section onClick={()=>this.navigateTo(`/team/${this.props.selectedOrganisation.id}`)}>
                    {this.props.selectedOrganisation.name}
                </Breadcrumb.Section>
            </React.Fragment>
            {orgTree}
            {users}
            {addTeam}
            {addUser}
        </Breadcrumb>

        return breadCrumb
    }
}

export default withRouter(BreadCrumbsPage)
